var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 589,
    viewBox: "0 0 96 589",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0089 54C76.8817 77.8664 84.6129 90.4621 87.8594 96.2471C93.0002 103.891 96.0002 113.095 96.0002 123V465C96.0002 476.142 92.204 486.397 85.8346 494.543C79.7817 502.777 66.5035 516.549 35.0089 534.5C13.8614 546.553 0.493194 566.511 0.0133651 586.75L0.0135381 512H0.0135401V77H0.0135382L0.0133843 2.24816C0.493203 22.4543 13.8614 41.9465 35.0089 54ZM0.0133797 0C-0.00447832 0.75014 -0.0043902 1.49964 0.0133843 2.24816L0.0133797 0ZM0.0133599 589L0.0133651 586.75C-0.00440997 587.5 -0.00449828 588.25 0.0133599 589Z",
    fill: "#5F6CE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBg);
export default __webpack_public_path__ + "static/media/sidebar-bg.5d3601b7119d0d03e34f867a793507a7.svg";
export { ForwardRef as ReactComponent };